import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class BookingRequestGuest extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      guestName: PropTypes.string.isRequired,
      checkIn: PropTypes.string.isRequired,
      listTitle: PropTypes.string.isRequired,
      threadId: PropTypes.number.isRequired,
    }).isRequired

  };

  render() {
    const { content: { guestName, listTitle, checkIn, threadId, logo, siteName, checkOut } } = this.props;
    let checkInDate, messageURL, checkOutDate
    checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : '',
      messageURL = url + '/message/' + threadId + '/guest';
    checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : ''

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
        <div style={body}>
          <div style={fontWeightBold}>
            Hi {guestName},
          </div>
          <EmptySpace height={20} />
          <div>
            Your reservation request has been sent to the host! They will respond within 24 hours.
          </div>
          <EmptySpace height={20} />
          <div style={marginBottom}><span style={fontWeightBold}>Listing Details:-</span></div>
          <div style={marginBottom}><span style={fontWeightBold}>Listing Name:</span> {listTitle}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Check-in:</span> {checkInDate}</div>
          <div><span style={fontWeightBold}>Check-out:</span> {checkOutDate}</div>
          <EmptySpace height={20} />
          <div>We'll keep you updated. Stay tuned!</div>
          <EmptySpace height={20} />
          <EmailSignature siteName={siteName} />
        </div>
        <EmptySpace height={40} />
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default BookingRequestGuest;